export default __webpack_public_path__ + "static/media/instagram.afc8be34.svg";